import { render, staticRenderFns } from "./EmojiFilter.vue?vue&type=template&id=602ac884&scoped=true&"
import script from "./EmojiFilter.vue?vue&type=script&lang=js&"
export * from "./EmojiFilter.vue?vue&type=script&lang=js&"
import style0 from "./EmojiFilter.vue?vue&type=style&index=0&id=602ac884&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602ac884",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/www/html/insights/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VChip,VTooltip})
